export default __webpack_public_path__ + "static/media/instagram_5.2464f88c.png";